import React from 'react'

function Policy() {
  return (
    <div>
      Privacy Policy
    </div>
  )
}

export default Policy
